import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Drawer, Menu, Dropdown } from 'antd';
import { MenuOutlined, DownOutlined, BulbOutlined } from '@ant-design/icons';
import Logo from '../images/logo_red.png';

const { Header } = Layout;
const menu = (
	<Menu>
		<Menu.Item>
			<a rel="noopener noreferrer" href="/">
				Compress
			</a>
		</Menu.Item>
		<Menu.Item>
			<a rel="noopener noreferrer" href="/compress-to-exact-size">
				Compress To Exact Size
			</a>
		</Menu.Item>
	</Menu>
);

const PageHeader = () => {
	const [isMobile, setMobile] = useState(window.innerWidth < 576);
	const [navVisible, setNavVisible] = useState(false);
	function showNavigation() {
		setNavVisible(true);
	}
	function hideNavigation() {
		setNavVisible(false);
	}
	const nav = (
		<ul className="navigation">
			<li><a href="/about">About</a></li>
			<li>
				<Dropdown overlay={menu}>
					<a href="/">Compress <DownOutlined /></a>
				</Dropdown>
			</li>
			<li><a href="/blog">Blog</a></li>
			<li className="feedback">
				<a
					href="https://imagecompressor.typeform.com/to/fJLWl3"
					target="_blank"
					rel="noopener noreferrer"
				>
					Feedback
					<BulbOutlined />
				</a>
			</li>
		</ul>
	);
	const mobileNav = (
		<div className="mobile-navigation">
			<MenuOutlined onClick={showNavigation} />
		</div>
	);
	useEffect(() => {
		setMobile(window.innerWidth < 576);
	}, []);
	return (
		<Header>
			<div className="logo">
				<a href="/">
					<img src={Logo} alt="imagecompressor.io logo" />
				</a>
			</div>
			{ isMobile ? mobileNav : nav }
			<Drawer onClose={hideNavigation} visible={navVisible}>
				<ul className="mobile-navigation">
					<li><a href="/">Compress</a></li>
					<li><a href="/compress-to-exact-size">Compress To Exact Size</a></li>
					<li><a href="/blog">Blog</a></li>
					<li><a href="/about">About</a></li>
					<li className="feedback">
						<a
							href="https://imagecompressor.typeform.com/to/fJLWl3"
							target="_blank"
							rel="noopener noreferrer"
						>
							<BulbOutlined />
							Feedback
						</a>
					</li>
				</ul>
			</Drawer>
		</Header>
	);
};
export default withRouter(PageHeader);



// WEBPACK FOOTER //
// ./src/components/PageHeader.js